import axios from "axios";
// List products with Api
export const PositionUpdate = async (jwt,user_id,course_id,urlc,pos_id) => {
  let url = process.env.REACT_APP_ADMIN_API_URL + `/position/` + pos_id
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'user_id': user_id,
    'course_id': course_id,
    "url": urlc
  });
  try {
    const response = await axios.put(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};